// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3gvEG","inner":"Form_inner__2pWGr","range":"Form_range__1efVf","name":"Form_name__2r2uN","actions":"Form_actions__12xyZ"};